
    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"form-group title-input required",class:{invalid: errors}},[_c('label',{attrs:{"for":"session-template-title"}},[_v("Title")]),_c('input',{ref:"titleInput",attrs:{"id":"session-template-title","tab-index":"1","type":"text"},domProps:{"value":value},on:{"input":function($event){return updateTitle()}}}),(errors)?[_c('div',{staticClass:"errors"},[_v("Title "+_s(errors.join(", "))+".")])]:_e()],2)}},
      staticRenderFns: []
    };
  